<template>
  <div>
    <el-row :gutter="10" class="mt-20 mb-30">
      <template v-for="(stat, index) in statsDeal">
        <el-col :key="index" :xs="24" :sm="12" :md="12" :lg="7" :xl="7">
          <Stats
            style="max-width: 550px"
            count-icon="mdi mdi-music-accidental-sharp"
            count-tooltip-text="Cantidad de oportunidade"
            :count="stat.Count"
            :total="formatMonto(stat.TotalAmount)"
            :text="stat.PhaseName"
            :icon="getStatIcon(stat.PhaseName)"
            :loading="loadingStat"
          />
        </el-col>
      </template>
    </el-row>

    <rabbey-toolbox
      :call-new="callNew"
      filterables
      @filter-search="handleSearch"
    >
      <!-- FITLRO DE VENDEDOR -->
      <div
        v-if="
          IsInRoles([
            roles.CEO,
            roles.SupervisorDeVentas,
            roles.SupervisorDeSoporteDeVentas,
            roles.SoporteVentas
          ]) && module === 'sales'
        "
        class="box mr-5"
      >
        <seller-selector v-model="seller_filter" />
      </div>

      <!-- FITLRO DE SOPORTE DE VENTA -->
      <div
        v-if="
          IsInRoles([
            roles.CEO,
            roles.SupervisorDeVentas,
            roles.SupervisorDeSoporteDeVentas
          ]) && module === 'call-center'
        "
        class="box mr-5"
      >
        <support-seller-selector v-model="support_seller_filter" />
      </div>

      <!-- FITLRO DE PRODUCTO -->
      <div class="mr-5" v-if="tabMetas" style="width: 150px">
        <product-selector
          v-model="product_filter"
          @update:product="handleProductUpdate"
        />
      </div>

      <!-- FITLRO DE AÑO -->
      <div class="box">
        <el-select
          v-model="year"
          placeholder="Año"
          size="mini"
          style="width: 150px"
        >
          <el-option
            v-for="item in years"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <!-- FITLRO DE METAS -->
      <div class="box mr-3" v-if="!tabMetas">
        <el-select
          v-model="metasValue"
          clearable
          placeholder="Metas"
          size="mini"
          style="width: 150px"
        >
          <el-option
            v-for="item in metas"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <!-- FITLRO DE CANTIDAD/MONTO -->
      <div class="box mr-3" v-if="tabMetas">
        <el-select v-model="typeFilter" size="mini" style="width: 150px">
          <el-option value="Q" label="Cantidad" />
          <el-option value="A" label="Monto" />
        </el-select>
      </div>

      <!-- FILTRO DE SERVICIO AL CLIENTE-->
      <!-- <div class="box mr-3" v-if="tabMetas">
        <CustomerServiceSellerSelector
          v-model="customers_service_seller_filter"
          @selection-change="handleChangeCustomerSeller"
        />
      </div> -->

      <!-- FITLRO DE FASES -->
      <!-- <div v-if="tabs.length > 0 && tabMetas" class="box mr-3">
        <el-select v-model="activeTab" size="mini" style="width: 150px">
          <el-option
            v-for="(stage, index) in tabs"
            :key="index"
            :value="stage.name"
            :label="stage.label"
          />
        </el-select>
      </div> -->

      <!-- FITLRO DE FECHA CIERRE/APERTURA -->
      <!-- <div class="box mr-5">
        <el-select v-model="isClose" v-if="isClose" size="mini">
          <el-option :value="true" label="Fecha de cierre" />
          <el-option :value="false" label="Fecha de apertura" />
        </el-select>
      </div> -->
    </rabbey-toolbox>

    <el-row>
      <el-col>
        <el-card>
          <el-tabs v-model="activeTab2" @tab-click="handleDealsTabs">
            <!--  VISTA DE LISTA DE OPORTUNIDADES POR ETAPA  -->
            <el-tab-pane label="Negociaciones por etapas" name="deal_by_stat">
              <el-row>
                <el-col :span="24">
                  <el-tabs
                    type="border-card"
                    v-model="activeTab"
                    v-loading="loadingTabs"
                    @tab-click="handleTabClick"
                  >
                    <el-tab-pane
                      v-for="(tab, index) in tabs"
                      :key="index"
                      v-model="stage"
                      :label="tab.label"
                      :name="tab.name"
                      lazy
                    >
                      <DealReportBySellers
                        v-if="tab.label === panelLabel"
                        ref="reportDeal"
                        :module="module"
                        :stages="tabs"
                        :typeFilter="typeFilter"
                        :productId="parseInt(product_filter)"
                        :year="year"
                        :is-close="isClose"
                        :seller-id="seller_filter"
                        :stage="stage"
                        :support-seller-id="support_seller_filter"
                      />
                      <rabbey-table-3
                        v-else
                        :ref="`table_${tab.name}`"
                        :key="tab.name"
                        :loading.sync="loading"
                        :data="tab.deals"
                        :columns="columns"
                        :actions="actions"
                        :border="true"
                        :stripe="true"
                        @rtable-push-action="onPushAction"
                        paginateFromApi
                        :paginationApi="{
                          currentPage: tab.currentPage,
                          pageSize: pageSize,
                          total: tab.totalItems
                        }"
                        @update-page-size="handleSizeChange"
                        @update-current-page="handleCurrentChange"
                        :class-table="{
                          'table-box': true,
                          'card-base': true,
                          'card-shadow--medium': false
                        }"
                      />
                    </el-tab-pane>
                    <!-- <template slot-scope="scope">
                      <el-tab-pane :label="panelLabel" name="deals_by_seller">
                      </el-tab-pane>
                    </template> -->
                  </el-tabs>
                </el-col>
              </el-row>
            </el-tab-pane>

            <!-- <el-tab-pane label="Metas por vendedor" name="dealsOP_by_seller">
              <TableGoalsVendorns
                :typeFilter="metasValue"
                :year="year"
                :sellerId="seller_filter"
                :isConfig="false"
              />
            </el-tab-pane> -->

            <el-tab-pane name="NewProspecting" label="Reporte de prospectos">
              <NewProspectsKpiVue />
            </el-tab-pane>

            <el-tab-pane label="Negociaciones" name="deals_by_rp7">
              <DealBusinessReport :year="year" />
            </el-tab-pane>

            <!-- <el-tab-pane label="Cotizaciones" name="deals_by_rp3">
              <DealReportByPhase
                ref="reportDealPresentations"
                :module="module"
                :seller-id="seller_filter || customers_service_seller_filter"
                :typeFilter="typeFilter"
                :dateFilter="dateFilter"
                :productId="parseInt(product_filter)"
                :year="year"
                phaseId="3"
              />
            </el-tab-pane> -->
            <el-tab-pane label="Cotizaciones" name="deals_by_rp9">
              <DealsReportCotizaciones :year="year" :seller="seller_filter" />
            </el-tab-pane>
            <!-- <el-tab-pane label="Presentaciones" name="deals_by_rp2">
              <DealReportByPhase
                ref="reportDealPresentations"
                :module="module"
                :seller-id="seller_filter || customers_service_seller_filter"
                :typeFilter="typeFilter"
                :dateFilter="dateFilter"
                :productId="parseInt(product_filter)"
                :year="year"
                phaseId="2"
              />
            </el-tab-pane> -->

            <el-tab-pane label="Presentaciones" name="deals_by_rp10">
              <DealsReportPresentaciones
                :year="year"
                :productId="product_filter"
                :seller="seller_filter"
              />
            </el-tab-pane>

            <el-tab-pane label="Citas" name="deals_by_rp5">
              <DealReportAgenda :year="year" />
            </el-tab-pane>

            <el-tab-pane label="Llamadas" name="deals_by_rp4">
              <Interactions />
            </el-tab-pane>
            <el-tab-pane label="Ventas" name="deals_by_rp6" :year="year">
              <ReportSales />
            </el-tab-pane>
            <el-tab-pane label="Supervision de ventas" name="deals_by_rp8">
              <ReportSuper
                :year="year"
                :customers_service_seller_filter2="
                  customers_service_seller_filter
                "
              />
            </el-tab-pane>

            <el-tab-pane label="KPI Ventas" name="deals_by_rp11">
              <kpiSales />
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>

    <DealsFormDrawer
      ref="form_view"
      :title="drawerTitle"
      :drawer.sync="drawer"
      :loading="true"
      v-bind="dealBind"
      @deal-created="handleDealCreated"
      @close-drawer="handleDrawerClose"
    />
    <DealsFormDeclined
      ref="form_view"
      :drawer.sync="drawerDeclined"
      :title="titleDeal"
      :loading="true"
      :dealId="dealId"
      :company="companyD"
      :win="winDeal"
      :dataNextPhase="datas"
      @close-drawer="handleDrawerClose"
    />
    <!-- <DealsFormNextPhase
      ref="form_DealsFormNextPhase"
      :drawer.sync="drawerNextPhase"
      :loading="true"
      :dealId="dealId"
      :negociasion="negociasion"
      :sellerId="sellerID"
      :client="companyD"
      :data="datas"
      @close-drawer="handleDrawerClose"
    /> -->

    <DealsPresentationDescriptions
      ref="descriptionDealPresentation"
      :drawer.sync="drawerDescriptionsPresentation"
      :data="dataDescriptiosPresentation"
      @close-drawer="handleDrawerClose"
    />

    <DealsDescriptions
      ref="descriptionDeal"
      :drawer.sync="drawerDescriptions"
      :data="dataDescriptios"
      @close-drawer="handleDrawerClose"
    />

    <DealsFormQuote
      ref="FormQuoteDeal"
      :drawer.sync="drawerFormQuote"
      :infoQuote="infoQuote"
      :dataNextPhase="datas"
      @close-drawer="handleDrawerClose"
    />

    <CalendarSelectDialog
      :calendars="calendars"
      :calendarSelectDialogVisible.sync="calendarSelectDialogVisible"
      :prospect="prospect"
      :contact="contact"
      :Client="Client"
      :Descripcion="Descripcion"
      :DealsId="dealId"
      :tipoAgenda="TipoAgenda"
      :openNextDialog="openNextDialog"
      :sellerName="sellerName"
    />

    <!-- <TaskFormDialog
      :TaskFormVisible="TaskFormVisible"
      :ObjectiveRow="ObjectiveRow"
      :WhatsThisFormFor="0"
      :NegotiationId="NegotiationId"
      @ClosingTaskFormDialog="ClosingTaskFormDialog"
      @TaskSaved="TaskSaved"

    /> -->

    <ObjectiveTasksDialog
      :ActualObjective="ActualObjective"
      :columnTaskCodeFrom="columnTaskCodeFrom"
      :NegotiationId="NegotiationId"
      :ObjectiveTasksDialogVisibility="ObjectiveTasksDialogVisibility"
      :IsInCharged="IsInCharged"
      @ObjectiveTasksDialogClosing="ObjectiveTasksDialogClosing"
    />

    <DialogNewInteractionForm
      :CustomerData="CustomerData"
      :isItVisible.sync="iteractionsVisibility"
      ref="dialogNewInteraction"
      :isCall="isCall"
      :isVisit="isVisit"
      :dealId="dealId"
      :isProspect="isProspect"
      :clientCode="clientCode"
      @closeIteractionsDialog="oncloseIteractionsDialog"
    />
  </div>
</template>

<script>
import axios from "axios";
import DealsFormDrawer from "@/components/deals/DealsFormDrawer.vue";
import DealsFormDeclined from "@/components/deals/DealsFormDeclined.vue";
// import DealsFormNextPhase from "@/components/deals/DealsFormNextPhase.vue";
import DealsDescriptions from "@/components/deals/DealsDescriptions.vue";
import DealsFormQuote from "@/components/deals/DealsFormQuote.vue";
import DealsPresentationDescriptions from "@/components/deals/DealsPresentationDescriptions.vue";
import DealReportBySellers from "@/views/modules/sales/reports/DealReportBySellers.vue";
// import DealReportByPhase from "@/views/modules/sales/reports/DealReportByPhase.vue";
// import TableGoalsVendorns from "@/views/modules/sales/reports/TableGoalsVendorns.vue";
import DealReportAgenda from "@/views/modules/sales/reports/DealReportAgenda.vue";
import ReportSales from "@/views/modules/sales/reports/ReportSales.vue";
import Interactions from "@/views/modules/customer_service/reports/Interactions.vue";
import ProductSelector from "@/components/Company/ProductSelector.vue";
import SellerSelector from "@/components/Company/SellerSelector.vue";
import SupportSellerSelector from "@/components/Company/SupportSellerSelector.vue";
import Deal from "@/models/deals/Deal";
import { formatterMoney, formatMonto } from "@/utils";
import { dealColumns, diaryColumns } from "@/columns";
import Stats from "@/components/CardTotalOriginal.vue";
import CalendarSelectDialog from "@/components/calendar/CalendarSelectDialog.vue";
import NewProspectsKpiVue from "@/views/modules/sales/kpi/NewProspectsKpi.vue";
// import CustomerServiceSellerSelector from "../Company/CustomerServiceSeller.vue";
import DealBusinessReport from "@/views/modules/sales/reports/DealBusinessReport.vue";
import DealsReportCotizaciones from "@/views/modules/sales/reports/DealsReportCotizaciones.vue";
import DealsReportPresentaciones from "@/views/modules/sales/reports/DealsReportPresentaciones.vue";
import ReportSuper from "@/views/modules/sales/reports/ReportSupervisorSales.vue";
// import CustomerServiceSelector from "../Company/CustomerServiceSelector.vue";
import kpiSales from "../../views/modules/sales/kpi/KPIventas.vue";
//import TaskFormDialog from "@/components/cmi/ObjectivesReport/TaskFormDialog"
import ObjectiveTasksDialog from "@/components/cmi/ObjectivesReport/ObjectiveTasksDialog";
import DialogNewInteractionForm from "@/components/interactions/DialogNewInteractionForm";

export default {
  name: "DealList",
  props: {
    module: {
      type: String,
      default: null,
      required: false
    }
  },
  components: {
    // "dialog-new-interaction-form": () =>
    //   import(
    //     /* webpackChunkName: "DialogNewInteractionForm" */ "@/components/interactions/DialogNewInteractionForm"
    //   ),
    DialogNewInteractionForm,
    DealsFormDrawer,
    DealReportBySellers,
    // DealReportByPhase,
    DealReportAgenda,
    ReportSales,
    Interactions,
    ProductSelector,
    SellerSelector,
    SupportSellerSelector,
    Stats,
    CalendarSelectDialog,
    DealsFormDeclined,
    // DealsFormNextPhase,
    DealsDescriptions,
    DealsPresentationDescriptions,
    // TableGoalsVendorns,
    DealsFormQuote,
    NewProspectsKpiVue,
    // CustomerServiceSellerSelector,
    DealBusinessReport,
    ReportSuper,
    DealsReportCotizaciones,
    DealsReportPresentaciones,
    kpiSales,
    //TaskFormDialog,
    ObjectiveTasksDialog
    // CustomerServiceSelector
  },
  data() {
    let self = this;

    return {
      isCall: false,
      isVisit: false,
      activeTab2: "deal_by_stat",
      detailSearch: "",
      asyncComponent: "peity",
      activeTab: "1",
      tabs: [],
      tabMetas: true,
      metasValue: "",
      metas: [
        { label: "Venta", value: 1 },
        { label: "Prospección", value: 2 },
        { label: "Presentación", value: 3 },
        { label: "Cotización", value: 4 }
      ],
      drawer: false,
      drawerDeclined: false,
      drawerDescriptions: false,
      drawerFormQuote: false,
      drawerDescriptionsPresentation: false,
      drawerNextPhase: false,
      sellerID: 0,
      dataDescriptios: {},
      dataDescriptiosPresentation: {},
      titleDeal: "",
      dealId: 0,
      TipoAgenda: 0,
      negociasion: "",
      companyD: "",
      datas: [],
      infoQuote: {},
      winDeal: false,
      items: null,
      row: null,
      CustomerData: null,
      productId: null,
      columns: dealColumns,
      columnsDiary: diaryColumns,
      loading: false,
      loadingTabs: false,
      initModel: {},
      drawerTitle: this.$t("sales.drawer_new.title"),

      dealBind: {
        initModel: Deal
      },
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit",
          condition: () => !["6", "8"].includes(self.activeTab)
        },
        {
          icon: "el-icon-right",
          label: "Siguiente etapa",
          command: "change-phase",
          condition: () => !["6", "8", "13"].includes(self.activeTab)
        },
        {
          icon: "el-icon-delete",
          label: "Negociacion declinada",
          command: "cancel",
          condition: () => !["6", "8", "5", "13"].includes(self.activeTab)
        },
        {
          icon: "el-icon-check",
          label: "Ganada",
          command: "win",
          condition: () => ["5", "13"].includes(self.activeTab)
        },
        {
          icon: "el-icon-close",
          label: "Declinada",
          command: "lost",
          condition: () => ["5", "13"].includes(self.activeTab)
        },

        {
          icon: "el-icon-document",
          label: "Ver detalles",
          command: "details",
          condition: () => ["6", "8"].includes(self.activeTab)
        },
        {
          icon: "el-icon-document",
          label: "Ver detalles de presentación",
          command: "details-presetantion",
          condition: () => ["3"].includes(self.activeTab)
        },
        {
          icon: "el-icon-notebook-1",
          label: "Agendar Cita",
          command: "agenda"
        },
        {
          icon: "el-icon-phone-outline",
          label: "Agendar llamada",
          command: "new_agenda_call"
        },
        {
          icon: "el-icon-plus",
          label: "Nueva Interacción",
          command: "new_interaction"
        },
        {
          icon: "el-icon-phone",
          label: "Registrar llamada",
          command: "new_interaction_call"
        },
        {
          icon: "el-icon-plus",
          label: "Registrar visita",
          command: "new_interaction_visit"
        },
        // {
        //   icon: "el-icon-plus",
        //   label: "Crear Tarea",
        //   command: "new_task"
        // }
        // ,
        {
          icon: "el-icon-view",
          label: "Ver Tareas",
          command: "view_task"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete",
          condition: () =>
            !["6", "8", "5", "13"].includes(self.activeTab) &&
            this.currentUser.Roles.filter((rol) => rol.Id === 37).length > 0
        }
      ],
      isClose: true,
      year: new Date().getFullYear(),
      typeFilter: "A",
      stage: "1",
      statsDeal: [],
      loadingStat: false,
      seller_filter: null,
      support_seller_filter: null,
      customers_service_seller_filter: 32,
      product_filter: 28,
      pageSize: 100,
      search: null,
      request: null,
      calendarSelectDialogVisible: false,
      calendars: [],
      prospect: null,
      contact: null,
      Client: null,
      Descripcion: null,
      showFilter: true,
      DealCustomerCode: "",
      TaskFormVisible: false,
      ObjectiveRow: {},
      NegotiationId: 0,
      ObjectiveTasksDialogVisibility: false,
      ActualObjective: {},
      columnTaskCodeFrom: "",
      IsInCharged: false,
      employId: 0,
      openNextDialog: false,
      isProspect: false,
      clientCode: "",
      sellerName: "",
      iteractionsVisibility: false
    };
  },
  async created() {
    this.seller_filter =
      this.currentUser.PositionID == 16
        ? null
        : parseInt(this.currentUser.PersonCode);
    // this.support_seller_filter = this.currentUser.PersonCode;
    this.getStatsDeal(this.year);
    await this.initialDeals();
    await this.IsHeinCharged().then((resp) => {
      this.IsInCharged = resp;
    });
  },
  computed: {
    panelLabel() {
      // if (this.module && this.module === "call-center") {
      //   return "Oportunidades";
      // }
      return "Cierres";
    },
    params() {
      return {
        userID: this.currentUser.UserID,
        PhaseID: parseInt(this.activeTab),
        companyID: this.currentCompany,
        ProductId: this.product_filter,
        BySeller: this.module === "sales",
        SellerId: this.seller_filter,
        SupportSellerId: this.support_seller_filter,
        limit: this.pageSize,
        page: this.currentTab.currentPage,
        search: this.search,
        Year: this.year
        // CustomerServicesId: this.customers_service_seller_filter
      };
    },
    dateFilter() {
      if (this.isClose) {
        return 3;
      } else if (!this.isClose) {
        return 2;
      } else {
        return 1;
      }
    },
    years() {
      const lowLevel = 2014;
      const currentYear = new Date().getFullYear();
      let Years = [];
      for (var i = lowLevel; i <= currentYear + 1; i++) {
        Years.push({ label: i, value: i });
      }
      return Years;
    },
    currentTab() {
      return this.tabs.find((f) => f.name === this.activeTab);
    }
  },
  methods: {
    // handleCustomerServiceChange(val) {
    //   if (val.length > 0) {
    //     this.customerServiceSelected = val[0].id;
    //   } else {
    //     this.customerServiceSelected = "";
    //   }
    // },
    async handleDealsTabs(tabs) {
      // await this.initialDeals(tabs.index)
      this.showFilter = !this.showFilter;
      this.isClose = true;
      if (tabs.name == "dealsOP_by_seller") {
        this.tabMetas = false;
      } else this.tabMetas = true;
    },
    formatterMoney,
    formatMonto,
    callNew() {
      this.dealBind.initModel = Deal;
      this.drawerTitle = this.$t("sales.drawer_new.title");
      this.$confirm(
        "Para quien es la nueva Negociacion?",
        "Nueva Negociacion",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "Cliente",
          cancelButtonText: "Prospecto",
          callback: (action) => {
            if (action === "close") return;

            if (action === "confirm") {
              this.drawerTitle = `Nueva Negociacion`;
              this.dealBind.isEdit = false;
              this.dealBind.isView = false;
              this.dealBind.isClient = true;
              this.dealBind.isProspect = false;
              this.dealBind.initModel = {
                CurrencyID: 3
              };
              this.dealBind.code = "";
              this.drawer = true;
            } else {
              this.drawerTitle = `Nueva Negociacion`;
              this.dealBind.isEdit = false;
              this.dealBind.isView = false;
              this.dealBind.isClient = false;
              this.dealBind.isProspect = true;
              this.dealBind.initModel = {
                CurrencyID: 3
              };

              this.dealBind.code = "";
              this.drawer = true;
            }
          }
        }
      );
    },
    async initialDeals(/*PhaseIndex = 0*/) {
      this.loading = true;
      this.loadingTabs = true;
      this.tabs = [];

      const response = await this.$http.get("/api/Phases/All");
      let OpenOpportunity = 0;

      const params = {
        UserID: this.currentUser.UserID,
        CompanyID: this.currentCompany,
        DealId: null,
        SellerId: this.seller_filter,
        SupportSellerId: this.support_seller_filter,
        Year: this.year,
        DateFilter: this.dateFilter,
        Month: null,
        PhaseID: null,
        ProductId: this.product_filter,
        OpenOpportunity,
        Limit: this.pageSize,
        Page: 1
      };

      const phases = response.data.filter((p) => p.Id !== 0);
      for (let i = 0; i < phases.length; i++) {
        const phase = phases[i];
        params.PhaseID = phase.Id;

        const { CurrentPage, ItemCount, Items } = await this.$http
          .get("/api/deals/DealReportByPhase/", {
            timeout: 99999999,
            params
          })
          .then(({ data }) => data);

        /*
            Items.map(deal => {
              //deal.InitialDate = '2022-07-03T00:00:00'
              const actualDate = new Date();
              const initialDate = deal.InitialDate
              deal.daysOpen = actualDate.diff(new Date(initialDate), 'days') //(actualDate - initialDate).getDate()
            })
            */

        this.tabs.push({
          label: phase.Name,
          name: `${phase.Id}`,
          value: `${phase.Id}`,
          deals: Items,
          currentPage: CurrentPage,
          totalItems: ItemCount
        });
      }

      this.tabs.splice(3, 0, {
        label: this.panelLabel,
        name: "deals_by_seller"
      });

      params.OpenOpportunity = 1;

      const { CurrentPage, ItemCount, Items } = await this.$http
        .get("/api/deals/DealReportByPhase/", {
          timeout: 99999999,
          params
        })
        .then(({ data }) => data);
      this.tabs.push({
        label: "Abiertas",
        name: "oportunidades_abiertas",
        deals: Items,
        currentPage: CurrentPage,
        totalItems: ItemCount
      });

      this.loading = false;
      this.loadingTabs = false;
    },
    async onPushAction(c) {
      var rowrow;
      rowrow = c.row;
      this.isCall = false;
      this.isVisit = false;

      this.CustomerData = rowrow;
      var { data } = await this.$http.get("/api/deals/GetByID/", {
        timeout: 3 * 60 * 1000,
        params: {
          DealsId: c.row.DealsId
        }
      });

      const isClient = data.CustomerCode
        ? data.CustomerCode.startsWith("CL")
        : false;
      const isProspect = data.CustomerCode
        ? data.CustomerCode.startsWith("C0")
        : false;
      this.DealCustomerCode = data.CustomerCode ?? "";

      let isItProspect = false;
      if (rowrow.TypeUser === "PROSPECTO") {
        isItProspect = true;
      } else {
        isItProspect = false;
      }
      let code = "";
      if (rowrow.TypeUser !== "PROSPECTO") {
        code = rowrow.CustomerCode;
      } else {
        code = rowrow.ContactDocument;
      }

      switch (c.command) {
        case "view": {
          this.drawerTitle = `Ver Negociacion #- ${c.row.DealsId}`;
          this.dealBind.isClient = isClient;
          this.dealBind.isProspect = isProspect;
          this.dealBind.code = this.DealCustomerCode;
          this.dealBind.initModel = {
            ...data
          };
          this.dealBind.isEdit = false;
          this.dealBind.isView = true;
          this.drawer = true;
          break;
        }

        case "edit": {
          this.drawerTitle = `Editar Negociacion #- ${c.row.DealsId}`;
          this.dealBind.isClient = isClient;
          this.dealBind.isProspect = isProspect;
          this.dealBind.code = this.DealCustomerCode;
          this.dealBind.initModel = {
            ...data
          };
          this.dealBind.isView = false;
          this.dealBind.isEdit = true;
          this.drawer = true;
          //this.dealBind.initialDeals = this.initialDeals();
          break;
        }

        case "new_interaction_call": {
          this.isCall = true;
          this.dealId = c.row.DealsId;
          this.isProspect = isItProspect;
          this.clientCode = code;
          this.iteractionsVisibility = true;

          //this.$refs.dialogNewInteraction.show(code, isItProspect);
          break;
        }

        case "new_interaction_visit": {
          this.isVisit = true;
          this.dealId = c.row.DealsId;
          this.isProspect = isItProspect;
          this.clientCode = code;
          this.iteractionsVisibility = true;

          //this.$refs.dialogNewInteraction.show(code, isItProspect);
          break;
        }

        case "new_interaction": {
          this.dealId = c.row.DealsId;
          this.isProspect = isItProspect;
          this.clientCode = code;
          this.iteractionsVisibility = true;

          //this.$refs.dialogNewInteraction.show(code, isItProspect);
          break;
        }

        // case "new_task": {
        //   this.ObjectiveRow = {
        //     ObjectiveCombinedId: "Obj-3182",
        //     ObjectiveShortDescription: "Tareas de Negociaciones",
        //     PerpectiveID: 2,
        //     ObjectiveId: 3182,
        //     DateInit: "2025-07-22",
        //     DateEnd: "2099-12-31"
        //   }
        //   this.NegotiationId = rowrow.DealsId;
        //   this.TaskFormVisible = true;
        //   break;
        // }
        case "view_task": {
          this.ActualObjective = {
            ObjectiveCombinedId: "Obj-3192",
            ObjectiveShortDescription: "Tareas de Negociaciones",
            PerpectiveID: 2,
            ObjectiveId: 3192,
            DateInit: "2025-07-22",
            DateEnd: "2099-12-31"
          };
          this.columnTaskCodeFrom = "TT";
          this.NegotiationId = rowrow.DealsId;
          // this.isInCharged = await this.IsHeinCharged();
          this.ObjectiveTasksDialogVisibility = true;
          break;
        }
        case "delete": {
          this.$prompt(
            "Indicar el porque",
            "Segura/o que desea eliminar este registro ?",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              inputValidator: (el) => {
                if (el === null) {
                  return false;
                }
              },
              inputErrorMessage: "Mensaje es requerido",
              inputType: "textarea"
            }
          )
            .then(({ value }) => {
              this.$http
                .post("/api/deals/Disable", {
                  dealId: c.row.DealsId,
                  Reason: value
                })
                .then(() => {
                  this.$store.commit("setSplashScreen", false);
                  this.$message.success("Negociacion eliminada");
                  this.__handlePagination();
                })
                .catch((error) => {
                  console.error(error);
                  this.$message.error("Error al eliminar la Negociacion");
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Eliminacion cancelada"
              });
            });
          break;
        }

        case "cancel": {
          this.titleDeal = "Detalle del Cliente que perdimos";
          this.dealId = c.row.DealsId;
          this.companyD = c.row.CompanyName;
          this.winDeal = false;
          this.drawerDeclined = true;
          break;
        }

        case "change-phase": {
          if (c.row.PhaseId == 2) {
            if (
              this.IsInRoles([
                this.roles.CEO,
                this.roles.SupervisorDeVentas,
                this.roles.SupervisorDeSoporteDeVentas,
                this.roles.SoporteVentas
              ]) ||
              this.currentUser.PositionID == 25 //rol gerente comercial
            ) {
              this.$confirm(
                "Segura/o que desea cambiar de fase este registro ?"
              )
                .then(() => {
                  this.$http
                    .post("/api/deals/ChangePhase", data)
                    .then(({ data }) => {
                      this.$store.commit("setSplashScreen", false);
                      this.$store.commit("deals/MOVE_DEAL", {
                        from: data.From,
                        to: data.To,
                        deal: data.Deal
                      });
                      this.$message.success("Etapa cambiada, exitosamente.");
                      this.__handlePagination();
                    })
                    .catch((error) => {
                      console.error(error);
                      this.$message.error("Error al cambiar la etapa.");
                    });
                })
                .catch(() => {});
              return;
            }
            this.$message.error(
              "No tienes permitido realizar esta cotización, comunícate con un soporte de venta o con el supervisor de venta."
            );
            return;
          } else if (c.row.PhaseId == 3) {
            if (
              // this.currentUser.EmployeeId == c.row.SupportSellerId ||
              // data.Id == 4 || //rol soporte de venta
              // data.Id == 37 || //rol ceo
              // data.Id == 50 || //rol Supervisor de ventas
              // data.Id == 51 || //rol Supervisor de soporte de ventas
              // this.currentUser.PositionID == 25 //rol gerente comercial
              this.IsInRoles([
                this.roles.CEO,
                this.roles.SupervisorDeVentas,
                this.roles.SupervisorDeSoporteDeVentas,
                this.roles.SoporteVentas
              ]) ||
              this.currentUser.PositionID == 25 //rol gerente comercial
            ) {
              var customerCODE = c.row.CustomerCode
                ? c.row.CustomerCode
                : c.row.ContactDocument;

              var VatRegistrationNumber = c.row.VatRegistrationNumberCustomer
                ? c.row.VatRegistrationNumberCustomer
                : c.row.VatRegistrationNumberContact;
              VatRegistrationNumber = VatRegistrationNumber
                ? VatRegistrationNumber
                : "ㅤ";

              var Address = c.row.AddressCustomer
                ? c.row.AddressCustomer
                : c.row.AddressContact;
              Address = Address ? Address : "ㅤ";

              var Address2 = c.row.Address2Customer
                ? c.row.Address2Customer
                : c.row.Address2Contact;
              Address2 = Address2 ? Address2 : "ㅤ";

              var city = c.row.CityCustomer
                ? c.row.CityCustomer
                : c.row.CityContact;
              city = city ? city : "ㅤ";

              var AccountReceivableExec = c.row.AccountReceivableExecCustomer
                ? c.row.AccountReceivableExecCustomer
                : "ㅤ";

              var CustomerServiceExec = c.row.CustomerServiceExecCustomer
                ? c.row.CustomerServiceExecCustomer
                : c.row.CustomerServiceExecContact;
              CustomerServiceExec = CustomerServiceExec
                ? CustomerServiceExec
                : "ㅤ";

              var Phone = c.row.CustomerPhone
                ? c.row.CustomerPhone
                : c.row.ContactPhone;
              Phone = Phone ? Phone : "ㅤ";

              this.infoQuote = {
                sellerId: c.row.SellerId,
                clientName: c.row.CompanyName,
                sellerImage: c.row.SalesPersonPhoto,
                deaId: c.row.DealsId,
                sellerName: c.row.SalesPersonName,
                customerCode: customerCODE,
                contactCode: c.row.ContactDocument,
                contactName: c.row.ContactName,
                quantity: c.row.Quantity,
                unitPrice: c.row.UnitPrice,
                totalAmount: c.row.TotalAmount,
                RNC_Cedula: VatRegistrationNumber,
                address: Address,
                address2: Address2,
                city: city,
                accountReceivableExec: AccountReceivableExec,
                customerServiceExec: CustomerServiceExec,
                customerEmail: c.row.CustomerEmail,
                contactEmail: c.row.ContactEmail,
                productName: c.row.ProductName,
                phone: Phone
              };
              this.datas = data;
              this.drawerFormQuote = true;
              this.$refs.FormQuoteDeal.getLastN();
              // this.$refs.FormQuoteDeal.getContactByCostumer();
              return;
            }
            this.$message.error(
              "No tienes permitido realizar esta cotización, comunícate con un soporte de venta o con el supervisor de venta."
            );
            // this.currentUser.Roles.every(data => {
            // });
            return;
          }

          var value = true;

          if (c.row.PhaseId == 1) {
            await this.$http
              .get(`/api/deals/ValidPhasedCita?DealId=${c.row.DealsId}`)
              .then(({ data }) => {
                if (!data) {
                  this.$message.error(
                    "Debe de crear una Cita para poder pasar a la Etapa de Presentacion"
                  );
                  value = false;
                }
              });
          }

          if (value) {
            this.$confirm("Segura/o que desea cambiar de fase este registro ?")
              .then(() => {
                this.$http
                  .post("/api/deals/ChangePhase", data)
                  .then(({ data }) => {
                    this.$store.commit("setSplashScreen", false);
                    this.$store.commit("deals/MOVE_DEAL", {
                      from: data.From,
                      to: data.To,
                      deal: data.Deal
                    });
                    this.$message.success("Etapa cambiada, exitosamente.");
                    this.__handlePagination();
                  })
                  .catch((error) => {
                    console.error(error);
                    this.$message.error("Error al cambiar la etapa.");
                  });
              })
              .catch(() => {});
          }

          break;
        }

        case "win": {
          this.titleDeal = "Detalle del Cliente que ganamos";
          this.dealId = c.row.DealsId;
          this.companyD = c.row.CompanyName;
          this.winDeal = true;
          this.datas = data;
          this.drawerDeclined = true;
          break;
        }

        case "lost": {
          this.titleDeal = "Detalle del Cliente que perdimos";
          this.dealId = c.row.DealsId;
          this.companyD = c.row.CompanyName;
          this.winDeal = false;
          this.drawerDeclined = true;
          break;
        }
        case "details": {
          this.$http
            .get("/api/deals/DetailsDealReportWinOrDeclined", {
              params: {
                DealId: c.row.DealsId,
                Options: "S"
              },
              timeout: 3 * 60 * 100
            })
            .then((resp) => {
              if (resp.data.length > 0) {
                this.drawerDescriptions = true;
                this.dataDescriptios = resp.data[0];
                this.$refs.descriptionDeal.formatterData(
                  resp.data[0].Date_Renovation,
                  resp.data[0].Price_Offer
                );
                this.$emit("close-drawer");
              } else {
                this.$message.error("Esta Negociacion no contiene detalles");
              }
            })
            .catch((error) => {
              this.$message.error("Error al cargar detalles", error);
            });

          break;
        }

        case "details-presetantion": {
          this.$http
            .get("/api/deals/GetValidateDataPresentation", {
              params: {
                DealId: c.row.DealsId,
                negociasion: c.row.DealDescription,
                Options: "S"
              },
              timeout: 3 * 60 * 100
            })
            .then((resp) => {
              if (resp.data.length > 0) {
                this.dataDescriptiosPresentation = resp.data[0];
                this.drawerDescriptionsPresentation = true;
                this.$refs.descriptionDealPresentation.formatterData(
                  resp.data[0].Date_Quotation,
                  resp.data[0].Date_Purchase
                );
                this.$emit("close-drawer");
              } else {
                this.$message.error("Esta Negociacion no contiene detalles");
              }
            })
            .catch((error) => {
              this.$message.error("Error al cargar detalles", error);
            });

          break;
        }

        case "agenda": {
          this.prospect = c.row.DealDescription;
          this.contact = c.row.ContactName;
          this.dealId = c.row.DealsId;
          this.TipoAgenda = 1; // tipo cita
          this.sellerName = c.row.SalesPersonName;

          await this.getEmployBySellerId(c.row.SellerId);

          this.Client =
            c.row.CustomerName != null
              ? c.row.CustomerName
              : c.row.ContactCustomerName;
          this.Descripcion = c.row.DealDescription;
          await this.$store
            .dispatch("calendar/getAllCalendarsForEmployee", this.employId)
            .then((response) => {
              this.calendars = response.data.filter(
                (calendar) => calendar.canEdit
              );
            });
          this.openNextDialog = true;
          // this.calendarSelectDialogVisible = true;
          break;
        }

        case "new_agenda_call": {
          this.prospect = c.row.DealDescription;
          this.contact = c.row.ContactName;
          this.dealId = c.row.DealsId;
          this.TipoAgenda = 3; // tipo llamada
          this.sellerName = c.row.SalesPersonName;

          await this.getEmployBySellerId(c.row.SellerId);

          this.Client =
            c.row.CustomerName != null
              ? c.row.CustomerName
              : c.row.ContactCustomerName;
          this.Descripcion = c.row.DealDescription;
          await this.$store
            .dispatch("calendar/getAllCalendarsForEmployee", this.employId)
            .then((response) => {
              this.calendars = response.data.filter(
                (calendar) => calendar.canEdit
              );
            });
          this.openNextDialog = true;
          // this.calendarSelectDialogVisible = true;
          break;
        }

        default:
          break;
      }
    },
    async getEmployBySellerId(sellerId) {
      await this.$http
        .get("/api/employees/GetEmployeeBySellerId", {
          params: {
            sellerId: sellerId
          }
        })
        .then((resp) => {
          if (resp.data) {
            this.employId = resp.data;
          }
        });
    },
    _refreshTable() {
      const table_ref = this.$refs[`table_${this.activeTab}`][0];
      table_ref.refreshParams = this.params;
      table_ref.refreshTable();
    },
    getStatsDeal() {
      this.loadingStat = true;
      this.$http
        .get("/api/deals/getstats", {
          params: {
            companySelected: this.currentCompany,
            year: this.year,
            SellerId: this.seller_filter,
            ProductId: this.product_filter,
            SupportSellerId: this.support_seller_filter
            // CustomerServiceId: this.customers_service_seller_filter
          }
        })
        .then((resp) => {
          this.statsDeal = resp.data.filter((stat) => stat.Id !== 0);
        })
        .finally(() => {
          this.loadingStat = false;
        });
    },
    getStatIcon(phaseName) {
      if (phaseName === "Nueva") {
        return "mdi mdi-new-box accent-text";
      }

      if (phaseName === "Presentación") {
        return "mdi mdi-presentation-play accent-text";
      }

      if (phaseName === "Ganadas") {
        return "mdi mdi-cash success-text";
      }

      if (phaseName === "Perdida") {
        return "mdi mdi-cash danger-text";
      }

      if (phaseName === "En el cliente") {
        return "mdi mdi-account warning-text";
      }

      if (phaseName === "Cotización") {
        return "mdi mdi-sale info-text";
      }
      return "mdi mdi-plus-box accent-text";
    },
    async handleSizeChange(size) {
      this.pageSize = size;
      await this.__handlePagination({ limit: size });
    },
    async handleCurrentChange(page) {
      await this.__handlePagination({ limit: this.pageSize, page });
    },
    handleChangeCustomerSeller(sellerId) {
      this.seller_filter = sellerId;
      this.customers_service_seller_filter = sellerId;

      this.getStatsDeal();
      this.__handlePagination({ SellerId: sellerId, limit: this.pageSize });
      this.$refs.reportDeal.$refs.table.refreshTable();
    },
    async __handlePagination(payload) {
      if (this.request) {
        this.request.cancel();
      }

      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel };

      if (this.search) {
        payload = { limit: this.pageSize, page: 1 };
      }

      this.loading = true;

      this.params.OpenOpportunity = 0;
      if (this.activeTab === "8") this.params.OpenOpportunity = 1;

      // eslint-disable-next-line no-unused-vars
      const { CurrentPage, ItemCount, Items } = await this.$http
        .get("/api/deals/DealReportByPhase/", {
          CancelToken: axiosSource.token,
          timeout: 99999999,
          params: {
            ...this.params,
            ...payload,
            PhaseId: parseInt(this.activeTab),
            DateFilter: this.dateFilter
          }
        })
        .then(({ data }) => data);

      const tab = this.tabs.find((f) => f.name === this.activeTab);
      tab.deals = Items;
      tab.currentPage = CurrentPage;
      tab.totalItems = ItemCount;

      this.loading = false;
    },
    handleSearch(search) {
      this.search = search;
      this.__handlePagination({
        search: search,
        limit: this.pageSize
      });
    },
    handleTabClick() {
      this.__handlePagination();
    },
    handleDealCreated() {
      this.getStatsDeal();

      this.__handlePagination({
        phaseID: this.activeTab
      });

      this.$refs.reportDeal.$refs.table.refreshTable();
    },
    handleProductUpdate(val) {
      this.product_filter = val;
      this.getStatsDeal();

      this.__handlePagination({
        phaseID: this.activeTab,
        limit: this.pageSize
      });

      this.$refs.reportDeal.$refs.table.refreshTable();
    },
    handleDrawerClose() {
      this.drawer = false;
      this.drawerDeclined = false;
      this.drawerDescriptions = false;
      this.drawerNextPhase = false;
      this.drawerDescriptionsPresentation = false;
      this.drawerFormQuote = false;
      this.__handlePagination();
    },
    ClosingTaskFormDialog() {
      this.TaskFormVisible = false;
    },
    async TaskSaved() {
      this.TaskFormVisible = false;
      await this.initialDeals();
    },
    ObjectiveTasksDialogClosing() {
      this.ObjectiveTasksDialogVisibility = false;
    },
    async IsHeinCharged() {
      let IsHeinChargedPromise = await new Promise((resolve, reject) => {
        this.loadingData = true;
        const parameters = {
          params: {
            employee: this.currentUser.EmployeeId
          }
        };
        this.$http
          .get("/api/departments/IsHeIncharged", parameters)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((err) => {
            this.$message.error(err);
            reject(err);
          });
      });
      return IsHeinChargedPromise;
    },
    oncloseIteractionsDialog() {
      this.iteractionsVisibility = false;
    }
  },
  watch: {
    year() {
      this.getStatsDeal();
    },
    seller_filter(val) {
      this.customers_service_seller_filter = val;
      this.getStatsDeal();
      this.__handlePagination({
        salesPersonId: val,
        SellerId: val
      });
      this.$refs.reportDeal.$refs.table.refreshTable();
    },
    // customers_service_seller_filter(val) {
    //   this.getStatsDeal();
    //   this.__handlePagination({ CustomerServicesId: val });
    //   this.$refs.reportDeal.$refs.table.refreshTable();
    // },
    product_filter(val) {
      this.getStatsDeal();
      this.__handlePagination({
        ProductId: val,
        limit: this.pageSize
      });
      this.$refs.reportDeal.$refs.table.refreshTable();
    },
    support_seller_filter(val) {
      this.getStatsDeal();
      this.__handlePagination({
        ProductId: val,
        SupportSeller: val
      });
      this.$refs.reportDeal.$refs.table.refreshTable();
    }
  }
};
</script>

<style lang="scss" scoped>
.col-filter {
  background-color: red;
  height: 60px;
}

.el-tabs__content {
  padding: 0 !important;
}
</style>
